interface Achievement {
    title: string;
    link: string;
    image: string;
}

export const achievements: Achievement[] = [
    {
        title: "Expert on Codeforces: Rating 1625 with 1600+ problems solved.",
        link: "https://codeforces.com/profile/prabhxs",
        image: "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/codeforces.svg"
    },
    {
        title: "Global Rank 68 and College Rank 1 in TCS Codevita Season 11.",
        link: "https://drive.google.com/file/d/1k_ou5e3IjQwyoxBmnNqEXyh25zNx7x1S/view?usp=sharing",
        image: "https://media.geeksforgeeks.org/wp-content/cdn-uploads/20220711155841/codevita.jpg"
    },
    {
        title: "5-Star Coder on CodeChef: Achieved Global Rank 8 in Starters 57 (Division 3).",
        link: "https://www.codechef.com/users/cu_np_2558",
        image: "https://cdn.jsdelivr.net/npm/simple-icons@3.1.0/icons/codechef.svg"
    },
    {
        title: "Global Rank 305 in Google Kickstart Farewell Round A'23.",
        link: "https://drive.google.com/file/d/1NWgnuFuL-pO6oIoR-Hn0RDcXSHNof6cc/view",
        image: "https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200908225219/What-is-Google-Kick-Start-Important-Dates-Eligibility-Contest-Details.png"
    },
    {
        title: "Guardian (8142 / 660470) Rank on LeetCode: Solved 1150+ DSA problems (Top 1.27% globally).",
        link: "https://leetcode.com/u/prabhxs/",
        image: "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/leet-code.svg"
    },
    {
        title: "5-Star Coder on GeeksforGeeks: Ranked in the Top 0.28% of 28,520 users.",
        link: "https://www.geeksforgeeks.org/user/prabhxs/",
        image: "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/geeks-for-geeks.svg"
    },
    {
        title: "Blue Rank (1225) on AtCoder: Positioned in the Top 6% globally.",
        link: "https://atcoder.jp/users/prabhxs",
        image: "https://img.atcoder.jp/assets/atcoder.png"
    },
    {
        title: "Institute Rank 1 on HackerEarth: Rating 1850 with AIR 123.",
        link: "https://www.hackerearth.com/@prabhxs/",
        image: "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/hackerearth.svg"
    }
];
